import { useContext } from "react";
import { useTranslation } from "react-i18next";
import FileDownloadedNotification from "./FileDownloadedNotification";
import JobsServiceApi from "../../../../../../../../api/jobsService/jobsServiceApi";
import useJobServiceApi from "../../../../../../../../api/jobsService/useJobServiceApi";
import { ConfigContext } from "../../../../../../../../context/ConfigContext";
import { RETURN_SUMMARY_EXCEL } from "../../../../../../../../utils/constants";
import { Notification } from "../../hooks/useNotifications/useNotifications";

interface ReturnsExcelNotificationProps {
  notification: Notification;
  accountId: string;
  expireNotification: (notificationId: number) => void;
  downloadFile: (url: string, fileName: string) => void;
}

const ReturnsExcelNotification = ({
  notification,
  accountId,
  expireNotification,
  downloadFile,
}: ReturnsExcelNotificationProps) => {
  const { t, i18n } = useTranslation("common");
  const {
    JOBS_SERVICE_URL,
    ENABLE_RBAC_AUTH_SUPPORT,
    ENABLE_RBAC_AUTH_SUPPORT_FOR_JOBS_SERVICE,
  } = useContext(ConfigContext);
  const { downloadJob } = useJobServiceApi();
  const { payload } = notification;
  const translationKeyPrefix =
    payload.type === RETURN_SUMMARY_EXCEL
      ? "notifications.returnSummaryDownload"
      : "notifications.returnsExcelDownload";

  const isJobsApiAuthEnabled =
    ENABLE_RBAC_AUTH_SUPPORT && ENABLE_RBAC_AUTH_SUPPORT_FOR_JOBS_SERVICE;

  const downloadReturnsExcel = async (accessToken: string) => {
    const serverFileName = `${payload.filename}.xlsx`;
    const fileResponse = isJobsApiAuthEnabled
      ? await downloadJob(payload.id, accountId, serverFileName, i18n.language)
      : await JobsServiceApi.downloadJob(
          JOBS_SERVICE_URL,
          payload.id,
          accountId,
          serverFileName,
          accessToken,
          i18n.language
        );

    downloadFile(URL.createObjectURL(fileResponse.data), serverFileName);
  };

  return (
    <FileDownloadedNotification
      notification={notification}
      expireNotification={() =>
        expireNotification(new Date(notification.createdAt).getTime())
      }
      successMessage={t(`${translationKeyPrefix}.success`)}
      failureMessage={t(`${translationKeyPrefix}.failure`)}
      downloadFunction={downloadReturnsExcel}
    />
  );
};

export default ReturnsExcelNotification;
